import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M8 2a8 8 0 0 0-6.162 13.101L8 8.939V2zM2.898 16.161C4.283 17.309 6.061 18 8 18s3.717-.691 5.102-1.839L8 11.061l-5.102 5.1zm11.264-1.06A7.965 7.965 0 0 0 16 10H9.061l5.101 5.101zM11 0v7h7a7 7 0 0 0-7-7z" />
  </svg>
);

export default SvgComponent;
